var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"landing-section"},[(_vm.landing)?_c('div',[_c('WizardForm',{attrs:{"landing":_vm.landing},on:{"landing-changed":_vm.landingChanged}})],1):_c('div',{staticClass:"text-center"},[_c('b-spinner')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }